import * as types from '../actions/actionTypes'
import initialState from './initialState'

export default function dataReducer (state = initialState.data, action) {
  switch (action.type) {
    case types.PASS_ARTICLE_ID:
      return {...state, article_id: action.id}
    case types.GET_CONTENT_ID:
      return {...state, idContent: action.data}
    case types.GET_CATEGORIES:
      return {...state, categories: action.categ}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js